import React, { useEffect, useState } from "react";
import { Container, Card, Button, Spinner, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getQuotation, sendQuotation } from "../../store/slices/quotation";
import { toast } from "react-toastify";

export default function QuotationPreview() {
  const { id } = useParams(); // quotationId
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [quotation, setQuotation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  /* ================= FETCH QUOTATION ================= */

  useEffect(() => {
    fetchQuotation();
  }, [id]);

  const fetchQuotation = async () => {
    try {
      setLoading(true);

      const res = await dispatch(getQuotation({ id })).unwrap();
      setQuotation(res.data?.[0]);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load quotation");
    } finally {
      setLoading(false);
    }
  };

  /* ================= SEND ================= */

  const handleSend = async () => {
    try {
      setSending(true);

      await dispatch(sendQuotation({ id })).unwrap();

      toast.success("Quotation sent successfully");

      navigate(-1);
    } catch (err) {
      console.error(err);
      toast.error("Failed to send quotation");
    } finally {
      setSending(false);
    }
  };

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p className="mt-2">Loading quotation...</p>
      </Container>
    );
  }

  if (!quotation) {
    return (
      <Container className="text-center mt-5">
        <p>Quotation not found</p>
      </Container>
    );
  }


  return (
    <Container>
      <Card className="p-4 mt-3 shadow-sm">
        <h4 className="mb-3">Quotation Details</h4>

        <Row className="mb-3">
          <Col md={6}>
            <p>
              <strong>Customer:</strong> {quotation.lead?.name}
            </p>
            <p>
              <strong>Phone:</strong> {quotation.lead?.phone}
            </p>
          </Col>
          <Col md={6}>
            <p>
              <strong>Travel Date:</strong>{" "}
           {new Date(quotation.travelDate)
  .toLocaleDateString("en-GB")
  .replace(/\//g, "-")}
            </p>
            <p>
              <strong>Total Pax:</strong> {quotation.totalPax}
            </p>
          </Col>
        </Row>
<Row>
{
  quotation?.options?.length > 0 && (

    <div className="mb-4 col-md-6">

      <h5 className="mb-3">
        Price Breakup
      </h5>

      {
        quotation.options.map(
          (opt, index) => (

          <Card
            key={index}
            className="mb-3 p-2 border"
          >

            <div className="d-flex justify-content-between align-items-center mb-3">

              <h6 className="mb-0" style={{ fontWeight: "600" }}>
                {opt.name}
              </h6>

              <h5 className="mb-0 text-success" style={{ fontWeight: "600" }}>
                ₹{opt.totalAmount || 0}
              </h5>

            </div>

            <Row>

              <Col md={3}>
                <p style={{ fontSize: "14px" }}>
                  <strong>Hotel:</strong>
                  <br />
                  ₹{
                    opt.pricingBreakup
                      ?.hotelTotal || 0
                  }
                </p>
              </Col>

              <Col md={3}>
                <p style={{ fontSize: "14px" }}>
                  <strong>Vehicle:</strong>
                  <br />
                  ₹{
                    opt.pricingBreakup
                      ?.vehicleTotal || 0
                  }
                </p>
              </Col>

              <Col md={3}>
                <p style={{ fontSize: "14px" }}>
                  <strong>Ferry:</strong>
                  <br />
                  ₹{
                    opt.pricingBreakup
                      ?.ferryTotal || 0
                  }
                </p>
              </Col>

              <Col md={3}>
                <p style={{ fontSize: "14px" }}>
                  <strong>Activity:</strong>
                  <br />
                  ₹{
                    opt.pricingBreakup
                      ?.activityTotal || 0
                  }
                </p>
              </Col>

              <Col md={3}>
                <p style={{ fontSize: "14px" }}>
                  <strong>Base Total:</strong>
                  <br />
                  ₹{
                    opt.pricingBreakup
                      ?.grandTotal || 0
                  }
                </p>
              </Col>

              <Col md={3}>
                <p style={{ fontSize: "14px" }}>
                  <strong>Markup:</strong>
                  <br />
                  ₹{
                    opt.pricingBreakup
                      ?.markupAmount || 0
                  }
                </p>
              </Col>

              <Col md={3}>
                <p style={{ fontSize: "14px" }}>
                  <strong>GST:</strong>
                  <br />
                  ₹{
                    opt.pricingBreakup
                      ?.gstAmount || 0
                  }
                </p>
              </Col>

              <Col md={3}>
                <p style={{ fontSize: "14px" }}>
                  <strong>Per Person:</strong>
                  <br />
                  ₹{
                    opt.pricingBreakup
                      ?.finalPerPerson || 0
                  }
                </p>
              </Col>

            </Row>

          </Card>
        ))
      }

    </div>
  )
}

      <Col md={6}>
       <h5 className="mb-3">
        Quotation Preview
      </h5>
  {!quotation.pdfUrl ? (
    <div className="text-center p-5">
      <Spinner animation="border" />
      <p className="mt-2">Generating PDF...</p>
    </div>
  ) : (
    <iframe
      src={quotation.pdfUrl}
      title="Quotation PDF"
      width="100%"
      height="600px"
      style={{
        border: "1px solid #ddd",
        borderRadius: "8px",
      }}
    />
  )}
</Col>

        <div className="d-flex justify-content-center mt-4 gap-3">
          <button
          className="submit-btn"
            onClick={handleSend}
            disabled={sending || !quotation.pdfUrl}
          >
            {sending ? "Sending..." : "Send to Customer"}
          </button>

          {/* DOWNLOAD */}
          <a href={quotation.pdfUrl} target="_blank" rel="noreferrer">
            <button className="submit-btn">
              Download PDF
            </button>
          </a>

          {/* BACK */}
          <button className="submit-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>
        </Row>
      </Card>
    </Container>
  );
}
